import React from "react";
import {FaCircle} from "react-icons/fa";

const StatusCell = ({active, text}) => (
    <span className="inline-flex items-center gap-2">
        <FaCircle color={active ? "#106b10" : "#d1d1d1"}/>
        {text ?? (active ? "Em andamento" : "Finalizado")}
    </span>
);

export default StatusCell;